
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 7 12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.109 11.442a.625.625 0 01-.884 0l-5-5a.625.625 0 010-.884l5-5a.625.625 0 01.884.884L1.55 6l4.558 4.558a.625.625 0 010 .884z","fill":"currentColor"}})])
          )
        }
      }
    